import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-325fae58"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "teach-data"
};
const _hoisted_2 = {
  class: "data-wrap-container"
};
const _hoisted_3 = {
  class: "title-wrap"
};
const _hoisted_4 = {
  class: "data-wrap"
};
const _hoisted_5 = ["target", "href"];
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "text"
};
const _hoisted_8 = {
  class: "count"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommonTitle = _resolveComponent("CommonTitle");

  return $data.teachData && $data.teachData.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_CommonTitle, null, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.menu && $props.menu.module_name || '教学数据'), 1)]),
    _: 1
  })]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teachData, ({
    name,
    num,
    targetUrl
  }, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "data-card",
      key: i
    }, [_createElementVNode("a", {
      target: targetUrl ? '_blank' : '_self',
      href: targetUrl ? targetUrl : 'javascript:void(0)'
    }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(name), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(num), 1)])], 8, _hoisted_5)]);
  }), 128))])])])) : _createCommentVNode("", true);
}